//
//
//
//
//
//

export default {
  props: {
    tag: {
      type: String,
      default: '1/1',
    },
  },
}
